import React from 'react';
import { useIntl } from 'react-intl';
import { TextField, MenuItem, InputAdornment, InputLabel } from '@mui/material';
import { useStyles } from '../hooks/useStyles';
import { IMaskPhoneInput } from '../../../auth/components/CheckInSystem';
import { UserRoles } from '../../../../interfaces/user';
import { IOrder } from '../../../../interfaces/order';

export function CompanyBuyer({ order, countryData }: { order?: IOrder; countryData: any }) {
  const intl = useIntl();
  const classes1 = useStyles();
  const { classes } = classes1;

  return (
    <div className={classes.fieldsContainer}>
      <div className={classes.fields}>
        <div className={classes.dates}>
          <TextField
            label={intl.formatMessage({ id: 'COMPANY.FORM.LEGAL_PERSON' })}
            value={order?.buyer_company?.name}
            type='text'
            margin='normal'
            variant='outlined'
            inputProps={{ readOnly: true }}
          />
          <TextField
            label={intl.formatMessage({ id: 'COMPANY.FORM.INN' })}
            value={order?.buyer_company?.inn}
            type='text'
            margin='normal'
            variant='outlined'
            inputProps={{ readOnly: true }}
          />
          <TextField
            label={intl.formatMessage({ id: 'COMPANY.FORM.SITE' })}
            value={order?.buyer_company?.site}
            type='text'
            margin='normal'
            variant='outlined'
            inputProps={{ readOnly: true }}
          />
        </div>
        {order?.buyer_company?.description && (
          <div style={{ marginTop: 10 }}>
            <InputLabel shrink>
              {intl.formatMessage({ id: 'PRODUCT.TABLE.DESCRIPTION' })}
            </InputLabel>
            <div
              dangerouslySetInnerHTML={{ __html: order?.buyer_company?.description }}
              style={{ color: 'black' }}
            />
          </div>
        )}
      </div>
      <div className={classes.fields}>
        <div className={classes.dates}>
          <TextField
            label={intl.formatMessage({ id: 'COMPANY.FORM.BRAND' })}
            value={order?.buyer_company?.brand}
            type='text'
            margin='normal'
            variant='outlined'
            inputProps={{ readOnly: true }}
          />
          {countryData && (
            <IMaskPhoneInput
              mask={countryData.mask}
              value={order?.buyer_company?.phone_number}
              type='tel'
              label={intl.formatMessage({ id: 'AUTH.INPUT.PHONE' })}
              margin='normal'
              className='kt-width-full'
              variant='outlined'
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <InputAdornment position='start'> +{countryData.code} </InputAdornment>
                ),
              }}
            />
          )}
          <TextField
            select
            margin='normal'
            label={intl.formatMessage({ id: 'USER.EDIT.ROLE' })}
            value={order?.buyer_company?.roles || ''}
            name='roles'
            variant='outlined'
            inputProps={{ readOnly: true }}
          >
            <MenuItem value={UserRoles.ROLE_VENDOR}>
              {intl.formatMessage({ id: 'COMPANY.ROLES.VENDOR' })}
            </MenuItem>
            <MenuItem value={UserRoles.ROLE_BUYER}>
              {intl.formatMessage({ id: 'COMPANY.ROLES.BUYER' })}
            </MenuItem>
          </TextField>
        </div>
      </div>
    </div>
  );
}
